import React, {useState} from "react";

// const DatePicker = require("react-mobile-datepicker-jalaali-persian");
import {Picker, newDate, DatePickerConfig} from "@persian-tools/persian-mobile-datepicker";

interface CustomDatePicker2Props {
  value?: string;
  onShowDatePicker?: any;
  onSetShowDatePicker?: any;
  onSetInputDateValue?: any;
  onBirthDateChange?: any;
}

const CustomDatePicker2: React.FC<CustomDatePicker2Props> = ({
                                                               value,
                                                               onShowDatePicker,
                                                               onSetShowDatePicker,
                                                               onSetInputDateValue,
                                                               onBirthDateChange,
                                                             }) => {
  const [defaultDate, setDefaultDate] = useState(new Date("1995-07-01T20:30:00.000Z"));


  const config: DatePickerConfig = {
    year: {},
    month: {},
    day: {},
  };

  function handleSubmit(selectedDate: any) {
    onSetShowDatePicker(false);
    // setSelectedDateValue(selectDate);
  }

  function handleChange(selectedDate: any) {
    const item = selectedDate.object;

    const month = item.month > 9 ? item.month : `0${item.month}`;
    const day = item.day > 9 ? item.day : `0${item.day}`;

    let selectDate = `${item.year}/${month}/${day}`;
    // console.log(selectDate);
    // const date = format(selectedDate.date, "d MMMM yyyy") as any;
    onSetInputDateValue(selectDate);
    onBirthDateChange(selectDate.replace(/\//g, ""));
    setDefaultDate(new Date(selectedDate.date));
  }

  return (
    // <DatePicker
    //   value={defaultDate}
    //   isOpen={onShowDatePicker}
    //   theme="ios"
    //   dateConfig={dateConfigMap2}
    //   onSelect={(item : any) => {
    //     setDateValue(item)
    //   }}
    //   onChange={(item : any) => setDefaultDate(item)}
    //   onCancel={() => {onSetShowDatePicker(false) }}
    //   confirmText= {<ConfirmLogo />}
    //   cancelText={<CloseIconX />}
    // />

    <Picker
      isOpen={onShowDatePicker}
      config={config}
      minDate={newDate({year: 1270, month: 9, day: 11})}
      maxDate={newDate({year: 1420, month: 1, day: 13})}
      onSubmit={handleSubmit}
      onChange={handleChange}
      onClose={() => {
        onSetShowDatePicker(false);
      }}
      initialValue={defaultDate}
      theme="auto"
    />
  );
};

export default CustomDatePicker2;
